/**
 * @file   src\mobile\components\WantAdListing\DraftWantAds.js
 * @brief  This file is responsible for showing draft want ads listing
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import WantAdFeatures from "./v2/WantAdFeatures";

const DraftWantAds = () => {
  return <WantAdFeatures />;
};

export default DraftWantAds;
